import type { BottomBarItemProps } from '@eliadmin/core/src/components/homepage/bottom-bar';
import type { BadgeProps } from '@eliadmin/core/src/components/ui/badge';
import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import type { InputProps } from '@eliadmin/core/src/components/ui/input';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { BiSolidCategory } from 'react-icons/bi';
import { FaXTwitter } from 'react-icons/fa6';
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
  FaRegUserCircle,
  FaTiktok,
  FaUser,
  FaYoutube,
} from 'react-icons/fa';
import { FiShoppingBag, FiHome, FiAlignLeft, FiHeart, FiSettings, FiUser } from 'react-icons/fi';
import {
  RiArrowRightSLine,
  RiFacebookLine,
  RiHourglassLine,
  RiInstagramLine,
  RiLinkedinLine,
  RiMenuFill,
  RiTwitterXLine,
} from 'react-icons/ri';
import { MdOutlineShoppingBag } from 'react-icons/md';
import { IoGridOutline } from 'react-icons/io5';
import { GoHome } from 'react-icons/go';

/** Override this for custom e-shop data, without the need of specific components override */
export const HEADER_CONFIG = {
  bottomBar: {
    items: [
      {
        key: 'home',
        href: () => ROUTES.HOME(),
        icon: <GoHome size={24} />,
        label: 'text160',
      },
      {
        key: 'categories',
        href: () => ROUTES.CATEGORIES(),
        icon: <IoGridOutline size={24} />,
        label: 'text176',
      },
      {
        key: 'cart',
        href: () => ROUTES.CART(),
        label: 'text343',
        icon: <MdOutlineShoppingBag size={24} />,
      },
      {
        key: 'favorites',
        href: () => ROUTES.FAVORITES(),
        label: 'text516',
        icon: <FiHeart size={24} />,
      },
      {
        key: 'profile',
        href: () => ROUTES.PROFILE(),
        label: 'text486',
        icon: <FaRegUserCircle size={24} />,
      },
    ] satisfies BottomBarItemProps[],
  },
  searchBar: {
    buttonVariant: 'default' as ButtonProps['variant'],
    inputVariant: 'outlined' as InputProps['variant'],
  },
  headerMain: {
    profile: {
      buttonVariant: 'outline' as ButtonProps['variant'],
      icon: <FiUser className="h-5 w-5" />,
    },
    favorites: {
      buttonVariant: 'outline' as ButtonProps['variant'],
      icon: <FiHeart className="h-5 w-5" />,
    },
    contact: {
      icon: <FiSettings className="h-6 w-6 fill-primary" />,
    },
    cart: {
      icon: <FiShoppingBag className="h-6 w-6" />,
      badgeVariant: 'accent' as BadgeProps['variant'],
    },
  },
  categoryButton: {
    icon: <FiAlignLeft className="h-5 w-5" />,
    text: 'text176',
  },
  sidebar: {
    triggerIcon: <RiMenuFill className="h-6 w-6" />,
    menuArrow: <RiArrowRightSLine className="h-6 w-6" />,
    menuItems: [
      {
        key: 'domov',
        title: 'Domov',
        icon: <RiHourglassLine className="h-6 w-6" />,
        href: () => ROUTES.HOME(),
      },
      {
        key: 'profil',
        title: 'Profil',
        icon: <RiHourglassLine className="h-6 w-6" />,
        href: () => ROUTES.HOME(),
      },
      {
        key: 'oblubene',
        title: 'Obľúbené',
        icon: <RiHourglassLine className="h-6 w-6" />,
        href: () => ROUTES.FAVORITES(),
      },
      {
        key: 'kosik',
        title: 'Košík',
        icon: <RiHourglassLine className="h-6 w-6" />,
        href: () => ROUTES.CART(),
      },
    ],
    ctaButtons: [
      {
        variant: 'accent',
        title: 'Call to Action',
        href: '/',
        className: '',
      },
      {
        variant: 'secondary',
        title: 'Action to Call',
        href: '/',
        className: '',
      },
    ],
    icons: [
      {
        key: 'instagram',
        icon: <RiInstagramLine className="h-6 w-6" />,
        href: 'www.instagram.com',
      },
      {
        key: 'facebook',
        icon: <RiFacebookLine className="h-6 w-6" />,
        href: 'www.facebook.com',
      },
      {
        key: 'linkedin',
        icon: <RiLinkedinLine className="h-6 w-6" />,
        href: 'www.linkedin.com',
      },
      {
        key: 'twitter',
        icon: <RiTwitterXLine className="h-6 w-6" />,
        href: 'www.twitter.com',
      },
    ],
  },
  socialMediaIcons: {
    facebook: <FaFacebook fill="#4267B2" />,
    instagram: <FaInstagram fill="#F56040" />,
    linkedin: <FaLinkedin fill="#0077B5" />,
    pinterest: <FaPinterest fill="#E60023" />,
    tiktok: <FaTiktok />,
    twitter: <FaXTwitter />,
    youtube: <FaYoutube fill="#FF0000" />,
  },
} as const;
